import { AppSteps } from "@/shared/Components";
import { LockIcon, MessageCloudIcon, PaymentIcon, SingleUserIcon } from "@/shared/icons";
import { UserRegistrationForm } from "@/entities/user-registration-form";
import { PhoneVerificationForm } from "@/entities/phone-verify-form";
import { PinCodeForm } from "@/entities/pin-code-form";
import { CaptchaModal } from "@/entities/captcha-modal";
import { Blocked } from "@/entities/blocked";
import { SuccessPayment } from "@/entities/success-payment";
import { CheckPayment, FlowType, PaymentForm } from "../../payment-form";
import { SignUpStep, useSignUpService } from "../model";
import styles from "./styles.module.scss";

export const SignUpContent = () => {
  const { state, methods } = useSignUpService();

  const {
    currentStep,
    userDetailsErrorMessage,
    phoneNumberError,
    resendCoolDown,
    phoneNumber,
    showCaptcha,
    pinFetching,
    smsSentCount,
  } = state;
  const { handleSubmitUserInfo, handleVerifySms, getNewSms, handleSubmitCaptcha, handleCreatePin } =
    methods;

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <UserRegistrationForm
            onSubmit={handleSubmitUserInfo}
            errorMessage={userDetailsErrorMessage}
          />
        );
      case 1:
        return (
          <PhoneVerificationForm
            onSubmit={handleVerifySms}
            getNewSms={getNewSms}
            errorMessage={phoneNumberError}
            resendCoolDown={resendCoolDown}
            phoneNumber={phoneNumber}
            smsSentCount={smsSentCount}
          />
        );
      case 2:
        return <PaymentForm flowType={FlowType.SIGN_UP} />;
      case 3:
        return <CheckPayment />;
      case 4:
        return <PinCodeForm onSubmit={handleCreatePin} loading={pinFetching} />;
      case 5:
        return <Blocked />;
      case 6:
        return <SuccessPayment />;
      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      {currentStep !== SignUpStep.SuccessPayment && (
        <AppSteps
          className={styles.steps}
          current={currentStep}
          direction="vertical"
          items={[
            {
              icon: <SingleUserIcon />,
            },
            {
              icon: <MessageCloudIcon />,
            },
            {
              icon: <PaymentIcon />,
            },
            {
              icon: <LockIcon stroke="white" />,
            },
          ]}
        />
      )}

      {renderStepContent()}
      <CaptchaModal onSubmit={handleSubmitCaptcha} isOpen={showCaptcha} />
    </div>
  );
};
